import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext } from '@ngxs/store';
import { PatchUserPreferences } from './user-preferences.actions';
import { UserPreferences } from './types';

const USER_PREFERENCES_STATE_NAME = 'userPreferences';

export type UserPreferencesStateModel = UserPreferences;

@State<UserPreferencesStateModel>({
  name: USER_PREFERENCES_STATE_NAME,
  defaults: {
    showOnlyMyArchivesByDefault: true,
    preferableClosSessionConfig: {},
  },
})
@Injectable()
export class UserPreferencesState {
  static preferences = createSelector(
    [UserPreferencesState],
    (state: UserPreferencesStateModel) => state,
  );

  static preferableClosSessionConfig = createSelector(
    [UserPreferencesState.preferences],
    (state: UserPreferences) => state.preferableClosSessionConfig || {},
  );

  static showOnlyMyArchives = createSelector(
    [UserPreferencesState],
    (state: UserPreferencesStateModel) => state.showOnlyMyArchivesByDefault,
  );

  static readonly migrations = [
    {
      key: USER_PREFERENCES_STATE_NAME,
      // techdebt https://github.com/Unoporoduction/CLOS_Frontend/issues/531
      version: undefined as number,
      migrate: <T extends UserPreferencesStateModel>(state: T): T => {
        const preferableClosSessionConfig = {
          ...state.preferableClosSessionConfig,
          public: false,
        };

        return {
          ...state,
          preferableClosSessionConfig,
          version: 1,
        };
      },
    },
  ] as const;

  @Action(PatchUserPreferences)
  onPatchPreferences(
    ctx: StateContext<UserPreferencesStateModel>,
    { payload }: PatchUserPreferences,
  ) {
    ctx.patchState(payload);
  }
}
